import { useRouter } from 'next/router';
import { FC, useCallback, useMemo } from 'react';
import { parseStorageProvider } from 'services/utilsService';
import { AlgoliaHitStorageProviderComponentProps } from 'types/algolia';
import StorageProviderItem from 'components/Common/StorageProviderItem/StorageProviderItem';
import { ROUTES } from 'constants/routes';

const SearchStorageProvidersItemCustom: FC<AlgoliaHitStorageProviderComponentProps> = ({
  hit,
}) => {
  const router = useRouter();

  const storageProviderParsed = useMemo(() => parseStorageProvider(hit), [hit]);

  const handleHitClick = useCallback(() => {
    router.push(
      `${ROUTES.STORAGE_PROVIDER}[slug]`,
      `${ROUTES.STORAGE_PROVIDER}${hit.id}`,
      {
        scroll: true,
      },
    );
  }, [router, hit.id]);

  return (
    <StorageProviderItem
      storageProvider={storageProviderParsed}
      clickable
      handleClick={handleHitClick}
    />
  );
};

export default SearchStorageProvidersItemCustom;
